<template>
  <div class="bghover bggrey paddingBottom20">
    <div class="content-head paddingLeftRight">
      <h3 class="marginZero paddingTop20">各城市缺失率主因</h3>
      <el-divider content-position="left"></el-divider>

      <el-form class="textAlignLeft">
        <el-form-item label="评估城市" class="marginZero">
          <el-cascader
            class="search-bar"
            :options="options"
            :props="props"
            collapse-tags
            v-model="assessCity"
            filterable
            size="medium"
            @change="assessChange"
          ></el-cascader>
        </el-form-item>
      </el-form>
    </div>

    <div class="content-body">
      <div
        id="data-city-main-miss-pull-chart"
        :style="{ height: eleheight + 'px' }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
// // @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "DataCity",
  data() {
    return {
      // assessPull: "PM2.5",
      assessCity: ["直辖市", "北京"],
      assessCityEn: "Beijing",
      eleheight: 320,
      props: { multiple: false, expandTrigger: "hover" },
      options: [],
      cities: [],
      chart: [],
    };
  },
  created() {
    const that = this;
    // 获取城市
    this.$axios
      // .post("/AQAssess/getData.php", {
      //   database: "cities",
      // })
      .get("/AQAssess/getcities")
      .then((res) => {
        that.cities = res.data;
        let options = [];
        that.cities.forEach((element) => {
          let add = false;
          for (let i = 0; i < options.length; i++) {
            if (options[i].value == element[0]) {
              options[i].children.push({
                value: element[1],
                label: element[1],
              });

              add = true;
              break;
            }
          }
          if (!add) {
            options.push({
              value: element[0],
              label: element[0],
              children: [{ value: element[1], label: element[1] }],
            });
          }
        });

        that.options = options;
      })
      .catch((e) => {
        this.$message({
          type: "info",
          message: "获取城市数据失败",
        });
      });
  },
  methods: {
    addCityEn() {
      this.cities.forEach((prov) => {
        if (prov[1] == this.assessCity[1]) {
          this.assessCityEn = prov[2];
          return;
        }
      });
    },

    assessChange() {
      this.updateCharts();
    },
    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getMissData();
    },

    getMissData() {
      this.addCityEn();
      this.$axios
        .get("/AQAssess/getCityMissMaindata/" + this.assessCityEn)
        .then((res) => {
          // console.log(res.data);

          let seasonZh = ["春", "夏", "秋", "冬"];
          let miss_data = [];
          const that = this;
          res.data.forEach((element) => {
            miss_data.push([
              element[1] + seasonZh[element[2] - 1],
              element[3],
              element[4],
            ]);
          });

          this.drawCityMainMissDataChart(
            this.chart[0],
            miss_data,
            this.assessCity[1]
          );
        });
    },

    drawCityMainMissDataChart(chart, miss_data, city) {
      // 转换成 heatmap data 格式[x, y, value]

      let heatMapData = [];
      miss_data.forEach((element) => {
        heatMapData.push([
          element[0],
          element[1],
          parseFloat(100 * element[2]).toFixed(1),
        ]);
      });

      let title = city + "各季度数据缺失率最高的污染物";

      let option = {
        title: {
          text: title,
          // subtext: title,
          padding: [
            25, // 上
            10, // 右
            5, // 下
            10, // 左
          ],
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            console.log(params);
            let text = "";
            params.forEach((param) => {
              text +=
                city +
                param.data[0] +
                "<br>" +
                param.marker +
                "缺失率最高的污染物为: " +
                param.data[1] +
                "<br>" +
                param.marker +
                "缺失率为：" +
                param.data[2] +
                "%";
            });

            return text;
          },
        },
        grid: {
          left: 20,
          right: 40,
          bottom: 10,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          splitArea: {
            show: true,
          },
        },
        yAxis: {
          type: "category",
          data: ["PM2.5", "PM10", "SO2", "NO2", "CO", "O3"],
          splitArea: {
            show: true,
          },
          axisLabel: {
            fontWeight: 700,
            fontSize: 12,
          },
        },
        series: [
          {
            type: "heatmap",
            data: heatMapData,
            label: {
              show: true,
              position: "inside",
              color: "#FFF",
              formatter: function (params) {
                return params.data[2] + "%";
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      chart.setOption(option);
      chart.hideLoading();
    },
  },
  mounted() {
    this.chart.push(
      this.$echarts.init(
        document.getElementById("data-city-main-miss-pull-chart")
      )
    );

    this.updateCharts();

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
};
</script>



